// eslint-disable-next-line import/no-import-module-exports
import React, { useEffect, useReducer } from 'react';
// eslint-disable-next-line import/no-import-module-exports
import m from 'moment';

// kudago.afisha.settings.PLACE_FUTURE_EVENTS_NUMBER
const PLACE_FUTURE_EVENTS_NUMBER = 30;
const q = require('queried');
const _ = require('./i18n');

const ReactIcons = {
  img: ({ iconClassName = '', iconAlt = 'icon', iconName = '' }) => <img src={`${window.kudago.staticBaseUrl}img/${iconName}.svg`} className={iconClassName} alt={iconAlt} />,
};

function EventListItem({ event }) {
  const eventDate = (evt) => {
    let date = '';
    if (evt.is_startless && evt.is_endless) {
      date = _('Permanently');
    } else if (evt.end_date) {
      date = `${m(m(evt.start_date)).format('D')} — ${m(m(evt.end_date)).format('D MMMM')}`;
    } else {
      date = m(m(evt.start_date)).format('D MMMM');
    }
    return date;
  };
  // eslint-disable-next-line no-param-reassign
  event.date = eventDate(event);

  return (
    <div className="eventsListItem">
      <a href={event.site_url} title={event.title} className="eventsListItem-link full-dn mb5">
        <span>
          {event.title}
        </span>
      </a>
      {event.thumbs
        && (
        <a href={event.site_url} className="eventsListItem-image-preview">
          <picture className="">
            <source
              className="lazyload"
              type="image/jpeg"
              media="(max-width: 340px)"
              srcSet={event.thumbs.l}
            />
            <source
              className="lazyload"
              type="image/jpeg"
              media="(min-width: 341px)"
              srcSet={event.thumbs.m}
            />
            <img
              src={event.thumbs.l}
              className="eventsListItem-image lazyload"
              alt={event.short_title}
            />
          </picture>
        </a>
        )}
      <div className="eventsListItem-info">
        <div className="eventsListItem-content">
          <header className="events-list-item-header mob-dn">
            <a href={event.site_url} title={event.title} className="eventsListItem-link">
              <span>
                {event.short_title || event.title}
              </span>
            </a>
            {event.tagline
              && <div className="events-list-item-tagline">{event.tagline}</div>}
          </header>
        </div>
        <div className="eventsListItem-date">
          {/* eslint-disable-next-line react/jsx-pascal-case */}
          <ReactIcons.img
            iconName="calendar"
            iconAlt="date"
            iconClassName="eventsList-dateIcon"
          />
          {event.date}
        </div>
        <div className="eventsListItem-details">
          {(event.free || event.price)
            && (
            <div>
              {/* eslint-disable-next-line react/jsx-pascal-case */}
              <ReactIcons.img
                iconName="rouble-2"
                iconAlt="price"
                iconClassName="eventsList-priceIcon"
              />
              <span>{(event.free && _('Free entrance')) || (event.price && event.price)}</span>
            </div>
            )}
        </div>
      </div>
    </div>
  );
}

const initialState = {
  mappedEvents: [],
  events: [],
  exclude: [],
};

const eventsListReducer = (state, action) => {
  switch (action.type) {
    case 'showMoreEvents': {
      const mappedEvents = state.events.slice(0, state.mappedEvents.length + 10)
        .map((event) => <EventListItem key={event.event_date_id} event={event} />);
      return {
        ...state,
        mappedEvents,
      };
    }
    case 'loadEvents': {
      const { events, exclude, tryMore } = action.payload;
      return {
        ...state,
        events,
        exclude,
        tryMore,
      };
    }
    default:
      break;
  }
  return state;
};

function EventsList() {
  const [state, dispatch] = useReducer(eventsListReducer, initialState);

  const fetchFutureEvents = (exclude) => {
    const setFutureEvents = (arr) => {
      const tryMore = arr.events.length === PLACE_FUTURE_EVENTS_NUMBER;
      const events = [...state.events, ...arr.events];
      dispatch({ type: 'loadEvents', payload: { events, exclude, tryMore } });
    };
    fetch(`/widgets/future-events/?place_id=${window.kudago.itemId}&exclude=${exclude.join()}`)
      .then((resp) => resp.json())
      .then((req) => setFutureEvents(req));
  };

  // get exclude and fetch events on mount
  useEffect(() => {
    const exclude = q.all('.eventsListItem')
      ? q.all('.eventsListItem').map((el) => `${el.dataset.dateId}`)
      : [];
    fetchFutureEvents(exclude);
  }, []);

  useEffect(() => {
    const loadMoreEventsHandler = () => {
      if (!state.events) return;
      dispatch({ type: 'showMoreEvents' });
    };
    if (q('.loadMoreButton')) {
      document.addEventListener('loadMoreEvents', loadMoreEventsHandler);
    }
    if ((state.events.length > 0) && (state.events.length === state.mappedEvents.length)) {
      if (state.tryMore) {
        const exclude = [...state.exclude, ...state.events.map((event) => event.event_date_id)];
        fetchFutureEvents(exclude);
      } else {
        const hideLoadMoreEventsButton = new CustomEvent('hideLoadMoreEventsButton', { bubbles: true });
        document.dispatchEvent(hideLoadMoreEventsButton);
      }
    }
    return () => {
      document.removeEventListener('loadMoreEvents', loadMoreEventsHandler);
    };
  }, [state.events, state.mappedEvents]);

  return (
    <div>
      {state.events && state.mappedEvents}
    </div>
  );
}

module.exports = EventsList;
